export const getTabListStyles = () => ({
  root: {
    marginTop: 4,
    '& button + button': {
      marginLeft: 24,
    },
  },
  divider: {
    marginTop: 5,
  },
});
